import l from "components/util/l";

const getNodeContent = (optionsDisplay, nodeValues, attribute, formSettings) => {
  const values = nodeValues;
  if (!Array.isArray(optionsDisplay))
    optionsDisplay = [optionsDisplay]

  if (optionsDisplay.length == 0) return "";

  let parsedDisplay = "";
  let idxSelectedOption = 0;
  // Evaluate conditions
  for (let idx = 0; idx < optionsDisplay.length; idx++) {
    let show = false;
    const item = optionsDisplay[idx];
    const showConditions = item?.show_if ?? [];
    for (const conditional of showConditions) {
      const variable = conditional?.variable ?? "";
      const value = conditional?.value ?? "";
      const condition = conditional?.condition ?? "EQUAL";
      const variableValue = values.find(val => val.name == variable)?.value

      if (condition == "EQUAL")
        if (variableValue == value) show = true;
      if (condition == "NOT_EQUAL")
        if (variableValue != value) show = true;
      if (condition == "GREATER_THAN")
        if (variableValue > value) show = true;
      if (condition == "LOWER_THAN")
        if (variableValue < value) show = true;
      if (condition == "GREATER_THAN_OR_EQUAL")
        if (variableValue >= value) show = true;
      if (condition == "LOWER_THAN_OR_EQUAL")
        if (variableValue <= value) show = true;
      if (condition == "CONTAINS")
        if (variableValue.includes(value)) show = true;
      if (show) idxSelectedOption = idx;
    }
  }
  // Translate the template before filling it: a composed string no longer matches its locale key
  if (optionsDisplay[idxSelectedOption][attribute])
    parsedDisplay = l(optionsDisplay[idxSelectedOption][attribute]);
  else parsedDisplay = "";


  const regex = /{([^}]+)}/g;
  const mentionRegex = /[@#][^\s]+|<span type="variable"(.*?)<\/span>/g;
  let matches = parsedDisplay.match(regex);

  if (matches) {
    for (const match of matches) {
      let name = match.substring(1, match.length - 1);
      let defValue = nodeValues.find((item) => item.name == name)?.value ?? "";

      if (!formSettings.fields) {
        parsedDisplay = parsedDisplay.replace(match, defValue);
        continue;
      }

      const inputs = formSettings.fields;
      const input = inputs.find((item) => item.name == name);

      if (!input) {
        parsedDisplay = parsedDisplay.replace(match, defValue);
        continue;
      }

      let variableDisplaySettings = {};
      const replacement = getBody(variableDisplaySettings, input, values);
      parsedDisplay = parsedDisplay.replace(match, replacement);
    }
  }

  parsedDisplay = parsedDisplay.replace(mentionRegex, "[ ]")
  return parsedDisplay;
}

const getBody = (settings, input, nodeValues) => {

  const showLabel = settings?.show_label ?? true;
  const limit = settings.limit;
  const separator = settings?.separator ?? " | ";

  let value = nodeValues.find((item) => item.name == input.name)?.value;
  if (!value) return "";

  if (input.type == "SELECT" && input.options) {
    let options = input.options;
    let newValue = value;
    if (showLabel) {

      const selectedOption = options?.find((option) => option.value == value);
      if (!selectedOption) return "";
      newValue = l(selectedOption.label);
    }
    if (limit) return newValue.substring(0, limit);
    return newValue;
  }

  if (input.type == "MULTI_SELECT" && input.options) {
    let options = input.options;
    let newValues = value;

    if (showLabel) {
      newValues = newValues.map((item) => {
        const selectedOption = options.find((option) => option.value == item);
        if (!selectedOption) return "";
        return l(selectedOption.label);
      })
    }

    if (limit) newValues = newValues.slice(0, limit);
    return newValues.join(separator);
  }

  if (limit) return String(value).substring(0, limit);
  return value;

}

const htmlToPlain = (html) =>
  html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()


export { getNodeContent, htmlToPlain };